import { render } from "./Edit.vue?vue&type=template&id=a580d37a&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=a580d37a&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a580d37a"],['__file',"src/assets/js/pages/Address/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a580d37a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a580d37a', __exports__)) {
    api.reload('a580d37a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=a580d37a&scoped=true", () => {
    api.rerender('a580d37a', render)
  })

}


export default __exports__